import { css, etiColors } from '@eti/styles';
import { constants, price as priceUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { Check } from '@phosphor-icons/react';
import type { PreSelectedExtraProducts } from '../../../models';

const preSelectedProductWrapperStyles = (numberOfPreSelectedProducts: number) => css`
  display: flex;
  font-size: 0.875rem;
  justify-content: space-between;
  ${numberOfPreSelectedProducts === 1 && `border-top: 1px solid ${etiColors.grayScale[4.5]};`}
  padding: 16px;

  > * {
    align-items: center;
    display: flex;
  }
`;

const productInformationStyles = css`
  margin-right: 6px;

  html[dir='rtl'] & {
    margin-left: 6px;
    margin-right: 0;
  }

  svg {
    flex-shrink: 0;
    height: 1rem;
    margin-right: 8px;
    width: 1rem;

    html[dir='rtl'] & {
      margin-left: 8px;
      margin-right: 0;
    }
  }
`;

const checkStyles = css`
  flex-shrink: 0;
  margin-left: 8px;

  html[dir='rtl'] & {
    margin-left: 0;
    margin-right: 8px;
  }
`;

interface PreSelectedProductProps {
  numberOfPreSelectedProducts: number;
  preSelectedExtraProduct: PreSelectedExtraProducts;
}

const PreSelectedProduct = ({
  preSelectedExtraProduct,
  numberOfPreSelectedProducts,
}: PreSelectedProductProps) => {
  const { t } = useTranslation();
  const { IconComponent, name, price } = preSelectedExtraProduct;
  const { LRE, PDF } = constants.unicodeControlCharacters;

  return (
    <div className={preSelectedProductWrapperStyles(numberOfPreSelectedProducts)} role="group">
      <div className={productInformationStyles}>
        <IconComponent aria-hidden />
        <span>{`${name} ${LRE}(${priceUtil.formatPrice(price)})${PDF}`}</span>
      </div>
      <div>
        {t('IbeClient.Added.Text')}
        <Check aria-hidden className={checkStyles} color="#17A71B" size="1rem" />
      </div>
    </div>
  );
};

export default PreSelectedProduct;
